import React from "react";

export const StatusRow = ({ status, user, date, showConnector }) => {
  const color =
    status === "approved"
      ? "#0BB783"
      : status === "applied"
      ? "#3699FF"
      : status === "rejected"
      ? "#F64E60"
      : status === "rejectReason"
      ? "#F64E60"
      : "#C19A6B";

  const titleMap = {
    applied: "Applied by",
    approved: "Approved by",
    rejected: "Rejected by",
    reason: "Reason of Apply:",
    rejectReason: "Reject Reason:",
  };

  return (
    <div
      style={{
        position: "relative",
        paddingLeft: 20,
        marginBottom: showConnector ? 18 : 0,
      }}
    >
      <div
        style={{
          width: 10,
          height: 10,
          borderRadius: "50%",
          backgroundColor: color,
          position: "absolute",
          left: 0,
          top: 6,
        }}
      />

      {showConnector && (
        <div
          style={{
            position: "absolute",
            left: 4,
            top: 18,
            width: 2,
            height: 25,
            backgroundColor: "#C4C4C4",
          }}
        />
      )}

      <div style={{ display: "flex", gap: 6, marginTop: 2, flexWrap: "wrap" }}>
        <span style={{ fontWeight: 600 }}>{titleMap[status]}</span>

        {status === "reason" || status === "rejectReason" ? (
          <span style={{ fontSize: 14 }}>{user ?? "-"}</span>
        ) : (
          <>
            <strong>{user ?? "-"}</strong>
            <span>on</span>
            <span>{date ?? "-"}</span>
          </>
        )}
      </div>
    </div>
  );
};
